<template>
  <oio-input style="width: 75%" :value="address" @update:value="handleChange" disabled :readonly="disabled"></oio-input>
  <oio-button class="k-action-item" size="small" @click="showModal">选择地址 </oio-button>
  <a-modal
    width="80%"
    v-model:visible="visible"
    title="选择地点"
    @ok="handleOk"
    @cancel="handleCancel"
    ok-text="确认"
    cancel-text="取消"
  >
    <div>
      <div>
        <!--工具条-->
        <oio-form>
          <oio-form-item style="position: relative">
            <oio-input
              v-model:value="inputVal"
              style="width: 330px"
              placeholder="请输入地址"
              @input="handleInput"
              @blur="handleBlur"
              @focus="showOptions = true"
            ></oio-input>
            <div v-show="showOptions && options.length > 0" class="option-box">
              <div class="option-item" v-for="item in options" @click="handleSelect(item)" :key="item.id">
                <text class="item-title">{{ item.title }}</text>
                <text class="item-address">{{ item.address }}</text>
              </div>
            </div>
          </oio-form-item>
          <oio-row>
            <oio-form-item label="场所名称">
              <oio-input disabled :value="title" placeholder="" style="width: 330px"></oio-input>
            </oio-form-item>
            <oio-form-item label="当前地址" style="margin-left: 24px">
              <oio-input disabled :value="address" placeholder="" style="width: 500px"></oio-input>
            </oio-form-item>
          </oio-row>
        </oio-form>
      </div>
      <div class="mapWrap">
        <div id="amapCont" class="amap" />
        <div class="lngTips" />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { OioInput, OioButton, OioFormItem, OioForm, OioRow } from '@kunlun/vue-ui-antd';
import { debounce } from 'lodash-es';

const KEY = '2c3205812ca986581049d6dff019ccb6';
const SECURITY_CODE = '56d14ea00534b4c72741f1d7b9790699';

export default {
  components: {
    OioRow,
    OioForm,
    OioFormItem,
    OioInput,
    OioButton
  },
  props: {
    changeOne: Function,
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      amap: null,
      premarker: null,
      marker: null,
      inputVal: '',
      latlngCurrent: '',
      visible: false,
      readOnly: false,
      title: '',
      address: '',
      geocoder: null,
      autoComplete: null,
      options: [],
      showOptions: false,
      amapScript: null
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.address = val.address;
        this.readOnly = val.readOnly;
      },
      deep: true
    }
  },
  mounted() {},
  // 参考地址：https://lbs.amap.com/api/javascript-api-v2/summary
  methods: {
    handleChange(val) {
      this.address = val;
    },
    showModal() {
      if (this.readOnly) return;
      this.visible = true;
      this.initMap();
    },
    handleOk() {
      this.visible = false;
      this.changeOne(this.address, this.latlngCurrent, this.title);
    },
    handleCancel() {
      this.visible = false;
      if (this.amap) {
        this.amap.destroy && this.amap.destroy();
        this.amap = null;
      }
      if (this.amapScript) {
        document.body.removeChild(this.amapScript);
        this.amapScript = null;
      }
      window.AMap = undefined;
    },
    initMap() {
      window.onMapFileLoad = () => {
        console.log('amap加载完成');
        this.createMap();
      };
      if (typeof AMap !== 'object') {
        this.loadAMap();
      } else {
        this.createMap();
      }
    },
    createMap() {
      const opts = { zoom: 18 };
      if (this.latlngCurrent) {
        const parts = this.latlngCurrent.split(',');
        // 高德地图坐标顺序为 [lng, lat]
        opts.center = [Number(parts[1]), Number(parts[0])];
      }
      this.amap = new AMap.Map('amapCont', opts);
      this.geocoder = new AMap.Geocoder({});
      this.autoComplete = new AMap.AutoComplete({});
      const timer = setTimeout(() => {
        this.createMarker();
        this.bindMapEvent();
        clearTimeout(timer);
      }, 500);
    },
    loadAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: SECURITY_CODE
      };
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://webapi.amap.com/maps?v=2.0&key=${KEY}&plugin=AMap.PlaceSearch,AMap.Geocoder,AMap.CitySearch,AMap.AutoComplete&callback=onMapFileLoad`;
      document.body.appendChild(script);
      this.amapScript = script;
    },
    handleBlur() {
      const timer = setTimeout(() => {
        this.showOptions = false;
        clearTimeout(timer);
      }, 200);
    },
    handleInput(e) {
      const val = e.target.value;
      debounce(async () => {
        if (val) {
          const res = await this.searchByKeyword(val);
          this.options = res.data;
          this.showOptions = true;
        } else {
          this.options = [];
          this.showOptions = false;
        }
      }, 300)();
    },
    handleSelect(item) {
      this.title = item.title;
      this.address = item.address;
      this.latlngCurrent = `${item.location.lat},${item.location.lng}`;
      const lnglat = [Number(item.location.lng), Number(item.location.lat)];
      this.amap.setCenter(lnglat);
      if (this.premarker) {
        this.amap.remove(this.premarker);
      }
      this.premarker = new AMap.Marker({
        position: lnglat,
        map: this.amap
      });
    },
    createMarker() {
      if (this.premarker) {
        this.amap.remove(this.premarker);
      }
      this.locationCityCenter();
    },
    locationCityCenter() {
      const citySearch = new AMap.CitySearch();
      citySearch.getLocalCity((status, result) => {
        if (status === 'complete' && result.info === 'OK' && result.bounds) {
          this.amap.setBounds(result.bounds);
        }
      });
    },
    searchByKeyword(keyword) {
      return new Promise((resolve, reject) => {
        if (!this.autoComplete) {
          reject('AutoComplete 未初始化');
          return;
        }
        this.autoComplete.search(keyword, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const data = (result.tips || [])
              .filter((tip) => tip.location && typeof tip.location === 'object')
              .map((tip, idx) => ({
                id: tip.id || `${tip.name}_${idx}`,
                title: tip.name,
                address: (tip.district || '') + (tip.address || ''),
                location: {
                  lat: tip.location.lat,
                  lng: tip.location.lng
                }
              }));
            resolve({ status: 0, data });
          } else {
            reject(result && result.info ? result.info : 'NO_DATA');
          }
        });
      });
    },
    bindMapEvent() {
      this.amap.on('click', (event) => {
        if (this.marker) this.amap.remove(this.marker);
        if (this.premarker) this.amap.remove(this.premarker);
        const lng = event.lnglat.getLng();
        const lat = event.lnglat.getLat();
        this.latlngCurrent = `${lat},${lng}`;
        this.marker = new AMap.Marker({
          position: [lng, lat],
          map: this.amap
        });
        if (this.geocoder) {
          this.geocoder.getAddress([lng, lat], (status, result) => {
            if (status === 'complete' && result.info === 'OK' && result.regeocode) {
              const regeocode = result.regeocode;
              this.address = regeocode.formattedAddress;
              const aoi = regeocode.aois && regeocode.aois[0];
              const poi = regeocode.pois && regeocode.pois[0];
              this.title = (aoi && aoi.name) || (poi && poi.name) || '';
            }
          });
        }
      });
      // 地图鼠标滑动事件
      //   const $lngTipsBox = document.querySelector(".lngTips");
      //   const mapBoxWidth = window.getComputedStyle(
      //     document.querySelector(".mapWrap")
      //   ).width;
      //   this.amap.on("mousemove", (event) => {
      //     $lngTipsBox.style.display = "block";
      //     $lngTipsBox.style.top = event.pixel.y + 10 + "px";
      //     $lngTipsBox.style.left = event.pixel.x + 15 + "px";
      //   });
      //   //鼠标离开
      //   this.amap.on("mouseout", (event) => {
      //     $lngTipsBox.style.display = "none";
      //   });
    }
  }
};
</script>

<style>
.amap {
  width: 100%;
  height: 500px;
}

.mapWrap {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  margin-top: 15px;
}

.lngTips {
  display: none;
  width: 255px;
  height: 40px;
  padding: 5px 7px;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 123456;
  background: #ffffff;
  border-radius: 5px;
  line-height: 20px;
  box-shadow: #eeeeee 1px 1px 3px;
  border: #eeeeee 1px solid;
  font-size: 12px;
}
</style>

<style lang="scss" scoped>
.k-action-item {
  margin-left: 20px;
}

.option-box {
  position: absolute;
  top: 35px;
  left: 0;
  width: 330px;
  border: 1px solid #d9d9d9;
  background: #fff;
  max-height: 400px;
  overflow-y: scroll;
  z-index: 1;

  .option-item {
    display: flex;
    flex-direction: column;
    padding: 8px 16px;
    user-select: none;

    &:not(:last-child) {
      border-bottom: 1px solid #d9d9d9;
    }

    &:hover {
      background: #d9d9d9;
    }

    .item-title {
      font-size: 13px;
      line-height: 1.2;
    }

    .item-address {
      margin-top: 3px;
      font-size: 12px;
      color: #666;
      line-height: 1.2;
    }
  }
}

:deep(.ant-form-horizontal .ant-form-item-control) {
  flex: none;
}

:deep(.ant-input-disabled) {
  color: rgba(0, 0, 0, 0.85);
}
</style>
